import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import * as React from "react";

import { MatchFailure } from "../layouts/LayoutRuleMatcher";
import { MatchError } from "../layouts/LayoutToVizConfig";
import {
  useDataNotFoundErrors,
  useEphemeralWorkspaceState,
} from "../WorkspaceCtx/hooks";

import styles from "./DataNotFoundMessage.module.css";

interface DataNotFoundMessageProps {
  panelId: string;
}

export function DataNotFoundMessage(props: DataNotFoundMessageProps) {
  const errors = useDataNotFoundErrors(props.panelId);
  const { isHydrating } = useEphemeralWorkspaceState();
  const [dismissed, setDismissed] = React.useState(false);

  if (dismissed || isHydrating || !errors || errors.length === 0) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      onClose={() => setDismissed(true)}
      className={styles.top}
    >
      <AlertTitle>Couldn&apos;t load the following data</AlertTitle>
      <ul
        style={{
          margin: 0,
          paddingLeft: "1.5em",
          listStyle: "disc",
        }}
      >
        {errors.map((error) => (
          <li
            key={`${error.ruleId}-${error.requirement.topicMessagePath}`}
            style={{ marginBottom: "0.5em" }}
          >
            {formatError(error)}
          </li>
        ))}
      </ul>
    </Alert>
  );
}

function formatError(error: MatchError): string {
  switch (error.reason.type) {
    case MatchFailure.NO_PATH_MATCH:
      return `No data in this workspace matches the path "${error.requirement.topicMessagePath}"`;
    case MatchFailure.NO_DATATYPE_MATCH:
      return `No data in this workspace matches the path "${error.requirement.topicMessagePath}" with data type "${error.requirement.dataType}"`;
    case MatchFailure.NO_COMPLETE_MATCH:
      return `Found more data in this workspace matching the path "${error.requirement.topicMessagePath}" than can be used in this panel`;
    case MatchFailure.NO_REQUIREMENTS_SPECIFIED:
      return "This panel has no data requirements specified";
    default:
      return error.reason.message;
  }
}
